import React from "react";
import "./../../styles/pages/ContactPageNew.css";
import "./../../styles/pages/CustomPage.css";
import hugImage from "../../assets/hug.jpg";

const ContactForm = () => {
  return (
    <div className="msf-container">
      <div className="msf-row">
        <div className="contact-text">
          <h2 className="custom-page-h2">Contacta con la asociación</h2>
          <div className="red-line"></div>
          <p className="info">
            Puedes encontrarnos a través del correo electrónico:&nbsp;
            <span className="email">
              <a href="mailto:proyectochicasrosas@gmail.com">
                proyectochicasrosas@gmail.com
              </a>
            </span>
          </p>
          <p className="info">
            Y a través de Facebook en:
            <span className="facebook">
              <a
                href="https://www.facebook.com/proyectochicasrosas"
                target="_blank"
                rel="noopener noreferrer"
              >
                Proyecto Chicas Rosas
              </a>
            </span>
          </p>
          <p className="info">
            El grupo se comunica de forma ágil mediante los grupos de{" "}
            <strong>WhatsApp</strong> puestos a disposición dependiendo de las
            actividades.
          </p>
          <p className="info">
            Las citas habituales de reunión son en la{" "}
            <strong>Casa Hermandad San Isidoro</strong>, calle Augusto Plasencia, 3. Sevilla.
            <br />
            (Frente a la parroquia, en la placita del crucifijo de forja)
          </p>
          <p className="info">
            <strong>Cuota anual:</strong> La cuota para pertenecer a la
            asociación es de <strong>10 € anuales</strong>.
          </p>
          <p className="info">
            Una vez que hayas contactado con nosotros y te hayamos dado la
            información puedes relizar una transferencia a la cuenta bancaria
            del BBVA <strong>ES9701827116110201591054</strong>.
          </p>
          <p>
            No olvides poner en el concepto de la transferencia tu nombre y
            apellidos, seguidos de "Cuota anual de inscripción".
          </p>
        </div>
        <div className="msf-image">
          <img
            className="contact-image"
            src={hugImage}
            alt="Medical assistance worldwide"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
